// src/ai/AIProviderFactory.ts
import { IAIProvider, AIConfig, AIServiceType, AIProviderCallbacks, BaseAIProvider } from './IAIProvider'
import { DeepSeekProvider } from './providers/DeepSeekProvider'
import { OpenAIProvider } from './providers/OpenAIProvider'
import { OllamaProvider } from './providers/OllamaProvider'
import { OpenRouterProvider } from './providers/OpenRouterProvider'

export class AIProviderFactory {
  private static instance: AIProviderFactory
  private globalCallbacks: AIProviderCallbacks = {}

  private constructor() { }

  static getInstance(): AIProviderFactory {
    if (!AIProviderFactory.instance) {
      AIProviderFactory.instance = new AIProviderFactory()
    }
    return AIProviderFactory.instance
  }

  // 设置全局回调
  setGlobalCallbacks(callbacks: AIProviderCallbacks) {
    this.globalCallbacks = callbacks
  }

  // 创建AI提供者实例
  createProvider(config: AIConfig): IAIProvider {
    let provider: IAIProvider

    switch (config.aiServiceType) {
      case AIServiceType.DeepSeek:
        provider = new DeepSeekProvider(config, this.globalCallbacks)
        break
      case AIServiceType.OpenAI:
        provider = new OpenAIProvider(config, this.globalCallbacks)
        break
      case AIServiceType.Ollama:
        provider = new OllamaProvider(config, this.globalCallbacks)
        break
      case AIServiceType.OpenRouter:
        provider = new OpenRouterProvider(config, this.globalCallbacks)
        break
      default:
        throw new Error(`Unsupported AI service type: ${config.aiServiceType}`)
    }

    return provider
  }

  // 获取可用的服务类型
  getAvailableServiceTypes(): AIServiceType[] {
    return Object.values(AIServiceType)
  }

  // 验证配置是否有效
  validateConfig(config: AIConfig): boolean {
    if (!config.aiServiceType || !config.baseUrl) {
      return false
    }

    // 检查服务类型是否支持
    if (!Object.values(AIServiceType).includes(config.aiServiceType)) {
      return false
    }

    return true
  }

  cancelRequest(requestId: string): boolean {
    return BaseAIProvider.cancelRequest(requestId)
  }

  // 创建配置的工厂方法
  createConfig(
    serviceType: AIServiceType,
    baseUrl: string,
    apiKey?: string,
    accountId?: string
  ): AIConfig {
    return {
      aiServiceType: serviceType,
      baseUrl,
      apiKey,
      accountId
    }
  }
}

// 导出单例实例
export const aiProviderFactory = AIProviderFactory.getInstance()